import { CLAIM } from './actionTypes';
import { START, SUCCESS, ERROR, FORM_HIDE, FORM_SHOW } from '../../consts';

import api from '../../apiSingleton';

export function showClaimForm (data) {
  return {
    type: CLAIM + FORM_SHOW,
    payload: data
  };
}

export function hideClaimForm () {
  return {
    type: CLAIM + FORM_HIDE
  };
}

export function createClaim (reasonId, text) {
  return (dispatch, getState) => {
    const claim = getState().getIn(['claims', 'form']).merge({
      reasonId,
      text
    }).toJS();

    dispatch({
      type: CLAIM + START
    });

    return api.claim.claimCreate(claim)
      .then((data) => {
        dispatch(hideClaimForm());

        return dispatch({
          type: CLAIM + SUCCESS,
          payload: data
        });
      })
      .catch((err) => {
        return dispatch({
          type: CLAIM + ERROR,
          payload: err.messages
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/Claims/actions.js